const PROMO_CODE_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
const PROMO_CODE_LENGTH = 8;

/**
 * Random promotional code: 8 chars, uppercase A–Z and digits 0–9.
 */
export const generateRandomPromotionalCode = () => {
  const alphabet = PROMO_CODE_ALPHABET;
  const length = PROMO_CODE_LENGTH;

  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = new Uint8Array(length);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => alphabet[b % alphabet.length]).join("");
  }

  let result = "";
  for (let i = 0; i < length; i++) {
    result += alphabet[Math.floor(Math.random() * alphabet.length)];
  }
  return result;
};
